const formatPageviewEvent = (event) => {
  return {
    ...event,
    content: JSON.stringify(event.content),
    library: 'Web',
    currentContextPath: document.location.href,
    definitionType: 'SIMILAR',
    eventType: 'PAGEVIEW',
    scope: 'LOCAL',
    snapshotProperties: [],
    startingPoint: ''
  };
};

export {
  formatPageviewEvent
};



/** WEBPACK FOOTER **
 ** ./src/redux/utils/eventsUtils.js
 **/